import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
// import BigNumber from 'bignumber.js'

// components
import Modal, { ModalProps } from '../../../components/bakery/Modal'
import ModalActions from '../../../components/bakery/ModalActions'
import ModalTitle from '../../../components/bakery/ModalTitle'
import { ButtonConfirmed } from '../../../components/Button'
import Loader from '../../../components/Loader'
import { AutoRow } from '../../../components/Row'

// hooks
import { useActiveWeb3React } from '../../../hooks'
// import { useAddPopup } from '../../../state/application/hooks'
import useTransfer from '../../../hooks/commonNft/useTransfer'

import { isAddress } from 'web3-utils'

const InputWrapper = styled.div`
  width: 312px;
  margin: 24px auto;
`
const TransferTextarea = styled.textarea`
  padding: 15px 20px;
  width: 100%;
  height: 100px;
  line-height: 20px;
  background: none;
  border: 1px solid ${({ theme }) => theme.bsBorder1};
  box-sizing: border-box;
  border-radius: 10px;
  color: ${({ theme }) => theme.text1};
  font-weight: bold;
  font-size: 16px;
  outline: none;
  contenteditable: true;
  resize: none;
  ::placeholder {
    color: ${({ theme }) => theme.text4};
  }
`
interface SellComboModalProps extends ModalProps {
  onConfirm?: (amount: string) => any
  tokenId: string
  title: string,
  type?: string
}

const SellComboModal: React.FC<SellComboModalProps> = ({
  onDismiss,
  onConfirm,
  tokenId,
  title,
  type
}) => {
  const { account, chainId } = useActiveWeb3React()
  const [address, setAddress] = useState('')
  const [pendingTx, setPendingTx] = useState(false)

  const onUserInput = (e: any) => {
    setAddress(e.target.value.trim())
  }

  // const addPopup = useAddPopup()
  const { onTransfer } = useTransfer(type)
  const orderTransfer = useCallback(async () => {
    try {
      setPendingTx(true)
      const closeModal = () => {
        setPendingTx(false)
        onDismiss && onDismiss()
      }
      await onTransfer(tokenId, account, address)
      closeModal()
    } catch (e) {
      console.log(e)
    }
  }, [account, address, onDismiss, onTransfer, tokenId])

  return (
    <Modal maxWidth={376}>
      <ModalTitle text={title} />
      <InputWrapper>
        <TransferTextarea
          value={address}
          placeholder="Please enter the address"
          onChange={event => {
            onUserInput(event)
          }}
        ></TransferTextarea>
      </InputWrapper>
      <ModalActions>
        <ButtonConfirmed
          fontSize={14}
          height={40}
          padding="0px 18px"
          onClick={onDismiss}
        >Cancel</ButtonConfirmed>
        <ButtonConfirmed
          disabled={pendingTx || !address || !isAddress(address, chainId)}
          fontSize={14}
          height={40}
          padding="0px 18px"
          onClick={orderTransfer}
        >
          {pendingTx ? (
            <AutoRow gap="6px" justify="center">
              Pending <Loader stroke="white" />
            </AutoRow>
          ) : 'Confirm'}
        </ButtonConfirmed>
      </ModalActions>
    </Modal>
  )
}

export default SellComboModal
